import React, { Suspense } from 'react';
import { VStack } from '@terra/ui-styled-system';
import { Spinner } from '../../components/spinner';
import { Text } from '../../components/text';
import type { HttpEditorProps } from './types';

const HttpEditorComponent = React.lazy(() =>
  import('./HttpEditor').then((m) => ({ default: m.HttpEditor })),
);

export function HttpEditorLazyLoad(props: HttpEditorProps) {
  return (
    <Suspense
      fallback={
        <VStack
          h="full"
          w="full"
          minHeight="36px"
          justifyContent="center"
          alignItems="center"
          gap={4}
          padding={4}
        >
          <Spinner size="lg" label="Loading Editor" />
          <Text fontSize="sm" color="fg.muted">
            Loading Editor
          </Text>
        </VStack>
      }
    >
      <HttpEditorComponent {...props} />
    </Suspense>
  );
}
